function ExportLogEntryVO(id, clinic, office, patient, receiverType, exportType, exportDate, dateFrom, dateTo, dispensed,
                          dispensedTo, notes, receipt, user, guardian, authorizedPerson, generationStatus, deniedPerson,
                          generatedFile) {
    this.id = id;
    this.clinic = clinic;
    this.office = office;
    this.offices = office;
    this.patient = patient;
    this.receiverType = receiverType;
    this.exportType = exportType;
    this.exportDate = exportDate;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.dispensed = dispensed;
    this.dispensedTo = dispensedTo;
    this.notes = notes;
    this.receipt = receipt;
    this.generatedFile = generatedFile;
    this.user = user;
    this.guardian = guardian;
    this.authorizedPerson = authorizedPerson;
    this.generationStatus = generationStatus;
    this.deniedPerson = deniedPerson;

    var _typeContext = {
        clinic: ClinicVO,
        office: OfficeVO,
        offices: OfficeVO,
        patient: PatientVO,
        exportDate: Date,
        dateFrom: Date,
        dateTo: Date,
        receipt: AttachmentVO,
        generatedFile: AttachmentVO,
        user: UserVO,
        guardian: GuardianVO,
        authorizedPerson: AuthorizedPersonVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}